import axios from "axios";

const API = process.env.REACT_APP_API_URL || "";
export const TOKEN_KEY = "ts_token";

const client = axios.create({ baseURL: API, timeout: 120000 });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token && !config.headers?.Authorization) {
    config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
  }
  return config;
});

export async function trackEvent(event, metadata = {}) {
  try {
    const existing = localStorage.getItem("ts_anonymous_id");
    const anonymousId = existing || crypto.randomUUID();
    if (!existing) localStorage.setItem("ts_anonymous_id", anonymousId);
    await client.post("/api/analytics/event", { event, anonymousId, metadata }, { timeout: 8000 });
  } catch {
    // Analytics must never break the product experience.
  }
}

export async function reportClientError(error, context = {}) {
  try {
    await client.post("/api/errors", {
      message: error?.message || String(error || "Unknown client error"),
      stack: error?.stack || null,
      context,
    }, { timeout: 8000 });
  } catch {
    // Error reporting is best-effort.
  }
}

export default client;
export { API };
